import getDeviceSettings from "../../requests/devices/getDeviceSettings";
var GetDeviceCommand = /** @class */ (function () {
    function GetDeviceCommand() {
    }
    /**
     * @param deviceId string
     * @param organisationId string
     *
     * @return {*}
     */
    GetDeviceCommand.prototype.execute = function (deviceId, organisationId) {
        return getDeviceSettings(deviceId, organisationId);
    };
    return GetDeviceCommand;
}());
export default GetDeviceCommand;
